<template>
  <ErrorLayout>
    <p>エラーコード：{{ errorCode }}</p>
    <p>エラーが発生しました。詳細確認させていただきますので、下記フォームより上記エラーコードと必要事項入力の上お問い合わせください。</p>
    <a :href="loginErrorForm">{{ loginErrorForm }}</a>
  </ErrorLayout>
</template>

<script>
import ErrorLayout from '@/views/pages/ErrorLayout/index.vue';

export default {
  components: {
    ErrorLayout,
  },
  computed: {
    errorCode() {
      const error = this.$store.getters['authError/get'];
      return error.data?.errorCode ? String(error.data.errorCode) : null;
    },
    loginErrorForm() {
      return process.env.VUE_APP_LOGIN_ERROR_FORM;
    },
  },
};
</script>

<style lang="scss"></style>
